export type ILocalStorage = {
  set: (key: string, value: string) => any,
  get: (key: string) => string,
  remove: (key: string) => any,
};

let storage: ILocalStorage;
export const setLocalStorage = (_storage: ILocalStorage) => storage = _storage;

export const localStorage = {
  get:    (key: string) => storage.get(key),
  set:    (key: string, value: string) => storage.set(key, value),
  remove: (key: string) => storage.remove(key),
}